export const HOTKEYS = {
  assigneePicker: 'a',
  labelPicker: 'l',
  milestonePicker: 'm',
  projectPicker: 'p',
  issueTypePicker: 't',
  // Keep in sync with the item-pickers:open-development command binding.
  developmentSection: 'd',
}
